module.exports = __webpack_public_path__ + "img/Calendar.52eb4c9.svg";